import { $, addAction, INIT, apiPost } from '@situation/setdesign.util';

// "Be the First to Know" signup on the detail page of a show that is not on sale. Posts by AJAX to the
// website's own REST route (notification-signup/submit); the website verifies reCAPTCHA and calls the
// private Foxtrot API server-side. The browser never calls Foxtrot.
addAction(INIT, () => {
    const $root = $('#notification-signup');
    if (!$root.length) {
        return;
    }

    const $form = $root.find('.presale-signup__form');
    const $message = $root.find('.presale-signup__message');
    const $submit = $form.find('button[type="submit"]');
    const $captcha = $root.find('.presale-signup__recaptcha');
    const siteKey = $root.data('recaptcha-key');
    const fallbackError = $root.data('error-message') || 'Something went wrong and your signup was not saved. Please try again.';
    let widgetId = null;

    // The enterprise script is enqueued with render=explicit; it may finish loading after this runs.
    const renderCaptcha = () => {
        if (widgetId !== null || !siteKey) {
            return;
        }
        const enterprise = window.grecaptcha && window.grecaptcha.enterprise;
        if (enterprise && typeof enterprise.render === 'function') {
            widgetId = enterprise.render($captcha[0], { sitekey: siteKey });
            return;
        }
        setTimeout(renderCaptcha, 300);
    };
    renderCaptcha();

    const showMessage = (html, isError) => {
        $message.html(html).toggleClass('presale-signup__message--error', !!isError).prop('hidden', false);
    };

    const captchaToken = () => {
        if (widgetId === null || !window.grecaptcha || !window.grecaptcha.enterprise) {
            return '';
        }
        return window.grecaptcha.enterprise.getResponse(widgetId) || '';
    };

    const resetCaptcha = () => {
        if (widgetId !== null && window.grecaptcha && window.grecaptcha.enterprise) {
            window.grecaptcha.enterprise.reset(widgetId);
        }
    };

    $form.on('submit', (e) => {
        e.preventDefault();

        const data = {
            show_id: $root.data('show-id'),
            full_name: ($form.find('[name="full_name"]').val() || '').trim(),
            email: ($form.find('[name="email"]').val() || '').trim(),
            phone: ($form.find('[name="phone"]').val() || '').trim(),
            notes: ($form.find('[name="notes"]').val() || '').trim(),
            recaptcha_token: captchaToken()
        };

        if (!data.full_name) {
            showMessage('Please enter your full name.', true);
            $form.find('[name="full_name"]').focus();
            return;
        }
        if (!data.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
            showMessage('Please enter a valid email address.', true);
            $form.find('[name="email"]').focus();
            return;
        }
        if (data.notes.length > 1000) {
            showMessage('Notes may not exceed 1,000 characters.', true);
            return;
        }
        if (siteKey && !data.recaptcha_token) {
            showMessage('Please complete the reCAPTCHA challenge.', true);
            return;
        }

        $message.prop('hidden', true);
        $submit.prop('disabled', true).addClass('loading');

        apiPost('notification-signup/submit', data)
            .done((response) => {
                const success = $('<div class="presale-signup__success" role="status"></div>').html(response.message || 'Thanks, you are on the list.');
                $form.replaceWith(success);
            })
            .fail((xhr) => {
                const serverMessage = xhr && xhr.responseJSON && xhr.responseJSON.message;
                showMessage(serverMessage || fallbackError, true);
                resetCaptcha();
            })
            .always(() => {
                $submit.prop('disabled', false).removeClass('loading');
            });
    });
});
